module.exports = __webpack_public_path__ + "img/card.ab01ecef.svg";